import {$} from '../util';
import SliderItem from './SliderItem';

const Hammer = window.Hammer;
const _allInstances = []; // all instances
const hammerSetup = {
  recognizers: [
    [
      Hammer.Swipe,
      {
        direction: Hammer.DIRECTION_HORIZONTAL
      }
    ]
  ]
};


$(window).on("resize", function(e) {
  // let t = e.data;
  for (let i = 0, l = _allInstances.length; i < l; i++) {
    void (_allInstances[i].active && _allInstances[i].resize());
  }
});


class Slider {
  constructor($wrp, { autoplay = true, initialIndex = 0, dotsEnabled = true}) {
    this.autoplay = autoplay;
    this.initialIndex = initialIndex;

    this.dotsEnabled = dotsEnabled || false;
    this._$outer_wrp = $($wrp);
    this._$inner_wrp = $(".slides", this._$outer_wrp).on(
      this._evt.pauseOnHover,
      this
    );
    this._$sizer_pic = $("img.sizer", this._$outer_wrp);

    if (this.dotsEnabled) {
      this._$dots = $(".dots", this._$outer_wrp).on(this._evt.pauseOnHover, this);
    }
    this._$arrows = $(".arrow", this._$outer_wrp)
      .on("click", this, this._evt.arrowClick)
      .on(this._evt.pauseOnHover, this);
    this.slides = [];
    this.lock = false;
    this.initialized = false;
    this.frozen = 0;
    this.hammer = new Hammer(this._$outer_wrp[0], hammerSetup);
    this.timerId = null;
    this.timerFn = () => {
      this.timerId = null;
      this.step();
    };

    if (this._$sizer_pic.length) {
      this._$sizer_pic.css('opacity', 0);
    }
  }

  init() {
    if (this.initialized) {
      return this;
    }
    this.start(false);
    // this.clearTimeOut();
    this._swipeleft = () => this.step("next");
    this._swiperight = () => this.step("prev");
    this.attachHammer();
    // konsole.log('image loading');
    this.initialized = true;
  };

  attachHammer() {
    this.hammer.on("swipeleft", this._swipeleft);
    this.hammer.on("swiperight", this._swiperight);
  }

  dettachHammer() {
    this.hammer.off("swipeleft", this._swipeleft);
    this.hammer.off("swiperight", this._swiperight);
  }

  clone($wrp, setup) {
    const slider = new Slider(
      $wrp,
      {
        autoplay: this.autoplay,
        initialIndex: this.getActiveSlideIndex(),
        ...(setup || {})
      }
    );
    this.slides.forEach((slide, i) => {
      slider.addSlide(slide.$slide.html(), i);
    });
    return slider;
  }

  freeze(n) {
    if ((this.frozen = n - 0 || 0) > 0) {
      this.clearTimeOut();
    }
    else {
      this.setTimeOut();
    }
    return this;
  };

  start() {
    const i = this.initialIndex || 0;
    void (this.slides[i] && this.slides[i].setActive(false));

    if (this.slides.length <= 1) {
      if (this.dotsEnabled) { this._$dots.hide(); }
      this._$arrows.hide();
    }
    else {
      this.setTimeOut();
    }
    return this;
  };

  clearTimeOut() {
    if (this.timerId) {
      window.clearTimeout(this.timerId);
      this.timerId = null;
    }
    return this;
  };

  setTimeOut(_delay = 4000, _restart) {
    if (this.timerId) {
      if (_restart) {
        this.clearTimeOut();
      }
      else {
        return this;
      }
    }
    if (this.autoplay) {
      this.timerId = window.setTimeout(this.timerFn, _delay);
    }
    return this;
  };

  addSlide($cont, _i) {
    const sliderItem = new SliderItem($cont, this, _i);
    _allInstances.push(sliderItem);
    this.slides.push(sliderItem);
    return sliderItem;
  };

  step(_slide) {
    if (this.slides.length < 2) {
      return this;
    }
    const activeIndex = this.getActiveSlideIndex() || 0;
    let nextIndex = null;

    if (_slide instanceof SliderItem) {
      nextIndex = $.inArray(_slide, this.slides);
    }

    if (_slide === "prev") {
      nextIndex = this.slides[activeIndex - 1]
        ? activeIndex - 1
        : this.slides.length - 1
      ;
    }
    else if (_slide === "next" || nextIndex === null) {
      nextIndex = this.slides[activeIndex + 1] ? activeIndex + 1 : 0;
    }

    if (
      nextIndex === activeIndex ||
      (this.slides[nextIndex] && this.slides[nextIndex].active)
    ) {
      return this;
    }

    this.setSlide(nextIndex, activeIndex);
    return this;
  };

  setSlide(index, _activeIndex = null) {
    const activeIndex = typeof _activeIndex === 'number'
      ? _activeIndex : this.getActiveSlideIndex()
    ;
    if (index !== activeIndex) {
      this.slides[activeIndex].unsetActive();
      this.slides[index].setActive(true);
      this.slides[index].resize();
      this.setTimeOut(undefined, true);
    }
  }

  getActiveSlideIndex() {
    let found = null;
    for (var i = 0, l = this.slides.length; i < l; i++) {
      if (this.slides[i].active) {
        if (found === null) {
          found = i;
        } // return the first occurrence
        else {
          this.slides[i].unsetActive();
        } // prevent accidental modifications
      }
    }
    return found;
  };

  destroy() {
    this.clearTimeOut();
    this.slides.forEach(slide => slide.destroy());
    this.dettachHammer();
    this.hammer.destroy();
    this._$inner_wrp.off(this._evt.pauseOnHover);
    if (this.dotsEnabled) {
      this._$dots.off(this._evt.pauseOnHover);
    }
    this._$arrows
      .off("click", this._evt.arrowClick)
      .off(this._evt.pauseOnHover);
    if (this._$sizer_pic.length) {
      this._$sizer_pic.css('opacity', '');
    }
    for (const p in this) {
      if (this.hasOwnProperty(p)) { delete this[p]; }
    }
    // console.log('SLIDE GARBAGE', this);

    this.garbage = true;
  }
}

Slider.prototype._evt = {
  arrowClick: function(e) {
    const that = e.data;
    e.preventDefault();
    e.stopPropagation();
    that.step($(this).hasClass("left") ? "prev" : "next");
    e.preventDefault();
  },
  pauseOnHover: {
    mouseenter: function(e) {
      // let t = e.data;
      // t.clearTimeOut();
    },
    mouseleave: function(e) {
      // let t = e.data;
      // t.setTimeOut();
    }
  }
};


Slider.SliderItem = SliderItem;



export default Slider;
